import { CardListsActions } from './actions'
import * as CardLists from './actions/types'
import { initialCardListsState } from './initialState'

const reducer = (state = initialCardListsState, action: CardListsActions) => {
  switch (action.type) {
    case CardLists.INIT_STORE:
      return {
        ...state,
        initCardLists: action.payload.cardLists,
        cardLists: action.payload.cardLists,
        updatedAt: Date.now(),
      }
    case CardLists.FETCHING:
      return {
        ...state,
        loading: true,
      }
    case CardLists.FETCHING_ERROR:
      return {
        ...state,
        loading: false,
      }
    case CardLists.FETCHING_SUCCESS:
      return {
        ...state,
        cardLists: action.payload.cardLists,
        loading: false,
        updatedAt: Date.now(),
      }
    case CardLists.FETCHING_MORE:
      return {
        ...state,
        loading: true,
      }
    case CardLists.FETCHING_MORE_ERROR:
      return {
        ...state,
        loading: false,
      }
    case CardLists.FETCHING_MORE_SUCCESS:
      return {
        ...state,
        cardLists: [
          ...state.cardLists.slice(0, action.payload.index),
          {
            ...state.cardLists[action.payload.index],
            cardviews: [...state.cardLists[action.payload.index].cardviews, ...action.payload.newPage.cardviews],
            more: action.payload.newPage.more,
          },
          ...state.cardLists.slice(action.payload.index + 1),
        ],
        loading: false,
      }
    case CardLists.SUBMIT_FILTERS: {
      return {
        ...state,
        cardLists: action.payload.cardLists,
        updatedAt: Date.now(),
      }
    }
    default:
      return state
  }
}

export default reducer
